// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'vue-awesome/icons';
import './components/custom-icons/giphy';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// Normalize legacy hashbang URLs like /#/mixology → /mixology before app mounts
(() => {
  try {
    const { pathname, hash, search } = window.location;
    // Match patterns like /#/<path> or just #/<path>
    if (hash && hash.startsWith('#/')) {
      const newPath = hash.slice(1); // remove leading '#'
      const target = newPath || '/';
      const query = search || '';
      if (pathname + hash !== target + query) {
        window.history.replaceState(null, '', target + query);
      }
    }
  } catch (e) {
    // no-op: if anything goes wrong, just continue
  }
})();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App },
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});



// WEBPACK FOOTER //
// ./src/main.js